exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".fade-transition{transition:all .5s ease}.fade-enter{opacity:1}.fade-leave{top:-1000px;opacity:0}.shake-transition{transition:all 5s ease;transform:rotateX(30deg)}.shake-enter{opacity:1}.shake-leave{transform:rotateX(0);opacity:1}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/common/scss/common/transition.scss
// module id = 600
// module chunks = 2